module.exports = __webpack_public_path__ + "img/HK.aac62941.webp";